export default [
  {
    id: 'smileys',
    label: 'Yüzler',
    icon: '😀',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃',
      '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜',
      '🤪', '🤨', '🧐', '🤓', '😎', '🥸', '🤩', '🥳', '😏', '😒', '😞', '😔',
      '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤',
      '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓',
      '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦',
      '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🤢', '🤮', '🤧',
    ],
  },
  {
    id: 'gestures',
    label: 'El hareketleri',
    icon: '👋',
    emojis: [
      '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘',
      '🤙', '👈', '👉', '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜',
      '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🫶',
      '🫰', '🫵', '🫱', '🫲', '🫳', '🫴', '👂', '👃', '👀', '👁️', '🧠', '🫀',
    ],
  },
  {
    id: 'people',
    label: 'İnsanlar',
    icon: '🙋',
    emojis: [
      '👶', '🧒', '👦', '👧', '🧑', '👨', '👩', '🧔', '👵', '👴', '🙍', '🙎',
      '🙅', '🙆', '💁', '🙋', '🧏', '🙇', '🤦', '🤷', '👮', '👷', '💂', '🕵️',
      '👩‍⚕️', '👨‍⚕️', '👩‍🎓', '👨‍🎓', '👩‍🏫', '👨‍🏫', '👩‍💻', '👨‍💻', '👩‍🔧', '👨‍🔧',
      '👩‍🍳', '👨‍🍳', '👩‍🎨', '👨‍🎨', '👩‍🚀', '👨‍🚀', '🦸', '🦹', '🧙', '🧚', '🧜', '🧞',
    ],
  },
  {
    id: 'animals',
    label: 'Hayvanlar ve doğa',
    icon: '🐶',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮',
      '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧', '🐦', '🐤', '🦄', '🐝',
      '🦋', '🐌', '🐞', '🐢', '🐍', '🦎', '🐙', '🦑', '🦀', '🐠', '🐟', '🐬',
      '🌸', '🌹', '🌺', '🌻', '🌼', '🌷', '🌱', '🌲', '🌴', '🍀', '🍁', '🍂',
      '☀️', '🌤️', '⛅', '🌧️', '⛈️', '❄️', '🌈', '🌊', '🔥', '✨', '⭐', '🌙',
    ],
  },
  {
    id: 'food',
    label: 'Yiyecek ve içecek',
    icon: '🍕',
    emojis: [
      '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒',
      '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🥦', '🥕', '🌽', '🥔', '🍞',
      '🥐', '🥨', '🧀', '🥚', '🍳', '🥞', '🧇', '🥓', '🍔', '🍟', '🍕', '🌭',
      '🥪', '🌮', '🌯', '🥗', '🍝', '🍜', '🍣', '🍱', '🍚', '🍛', '🍦', '🍩',
      '🍪', '🎂', '🍰', '🧁', '🍫', '🍿', '☕', '🍵', '🥤', '🧃', '🍷', '🍺',
    ],
  },
  {
    id: 'activities',
    label: 'Aktiviteler',
    icon: '⚽',
    emojis: [
      '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🏓', '🏸',
      '🥅', '⛳', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛼', '⛸️', '🎿',
      '🏆', '🥇', '🥈', '🥉', '🏅', '🎖️', '🎯', '🎮', '🎲', '🧩', '🎨', '🎭',
      '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎸', '🎬', '🎟️', '🎪', '🎉', '🎊',
    ],
  },
  {
    id: 'travel',
    label: 'Seyahat ve yerler',
    icon: '🚗',
    emojis: [
      '🚗', '🚕', '🚌', '🏎️', '🚓', '🚑', '🚒', '🚚', '🚲', '🛵', '🏍️', '🚂',
      '🚆', '🚇', '✈️', '🚀', '🚁', '⛵', '🚢', '⚓', '⛽', '🚦', '🗺️', '🧭',
      '🏠', '🏡', '🏢', '🏥', '🏦', '🏨', '🏪', '🏫', '🏖️', '🏝️', '🏕️', '⛰️',
      '🗼', '🗽', '🎡', '🎢', '🌍', '🌎', '🌏', '🌅', '🌇', '🌃', '🌉', '🛣️',
    ],
  },
  {
    id: 'symbols',
    label: 'Semboller',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕',
      '💞', '💓', '💗', '💖', '💘', '💝', '💟', '✅', '☑️', '✔️', '❌', '⭕',
      '⚠️', '🚫', '❓', '❗', '‼️', '⁉️', '💯', '🔔', '🔕', '💬', '💭', '🗨️',
      '📌', '📍', '🔗', '💡', '🎁', '🛍️', '💰', '💳', '📦', '📣', '🔒', '🔓',
      '⬆️', '⬇️', '⬅️', '➡️', '↗️', '↘️', '🔄', '▶️', '⏸️', '⏳', '⌛', '🆕',
    ],
  },
]
